import type { NoContainerResolverContext } from '@source-components-react/types';
import { isBlockEnclosingTag } from './enclosing-tags';
import { resolveEnclosingTag } from './resolve-enclosing-tag';

/**
 * RText needs a wrapper div for the column's box styles unless it is about to
 * render a block-level element that can hold those styles itself.
 *
 * - No enclosing tag: bare text with no element to style → wrapper needed.
 * - Inline tag (`span`, `em`, `code`, …): vertical margin/padding and width
 *   are ignored on inline boxes → wrapper needed.
 * - Block tag (`p`, `div`, `h1`, `section`, …): RText puts styleProps on the
 *   tag itself → no wrapper, one less element in the DOM.
 */
export const resolveNoContainer = ({
  componentAttributes,
}: NoContainerResolverContext): boolean =>
  !isBlockEnclosingTag(resolveEnclosingTag(componentAttributes));
